<template>
    <div>
        <HeaderItem> </HeaderItem>
        <div class="subject">
            <div class="list-group">
                <div class="list-group-header aeroiotflex_row">
                    <div class="grid-imgBox" style="cursor: pointer">
                        <img
                            :src="
                                appData.base64icon
                                    ? appData.base64icon
                                    : defaultImg
                            "
                        />
                    </div>
                    <div class="systemName">{{ appData.name }}</div>
                </div>

                <div class="groupImgContent aeroiotflex_center">
                    <img :src="previewImgUrl" alt="" />
                </div>
                <div class="buttonContent aeroiotflex_center">
                    <div
                        class="replayOpenButton aeroiotflex_center"
                        @click="openAPP"
                    >
                        申请开通
                    </div>
                </div>
            </div>
        </div>
        <!-- <mobileFootter /> -->
        <appDowloadModule />
        <!-- 移动端申请开通 -->
        <el-dialog
            class="experienceButtonDialog experienceButtonDialog2"
            :visible.sync="dialogVisible3"
            width="315px"
            :before-close="handleClose3"
        >
            <span slot="title"></span>
            <div class="aeroiotflex_col" style="align-items: center">
                <div
                    class="experienceButtonDialogRightIcon"
                    style="margin-bottom: 26px"
                >
                    <i class="el-icon-check"></i>
                </div>

                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    2个工作日内会有专属客户经理与您联系
                </div>
                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    请保持您的电话畅通如需提前开通其他需求
                </div>
                <div
                    style="
                        line-height: 24px;
                        text-algin: center;
                        color: #999999;
                        font-size: 12px;
                    "
                >
                    请联系<span
                        style="
                            font-size: 16px;
                            color: #6c85ff;
                            font-weight: 600;
                        "
                        >400-7700-140</span
                    >
                </div>

                <div
                    class="experienceButtonInDialog experienceButtonInDialog2"
                    style="margin-top: 30px"
                    @click="dialogVisible3 = false"
                >
                    确认
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import HeaderItem from "@/components/HeaderItem";
import mobileFootter from "@/components/mobileFootter";
import appDowloadModule from "@/components/appDowloadModule";
export default {
    data() {
        return {
            dialogVisible3: false,
            appData: {},
            previewImgUrl: "",
            defaultImg:
                "data:image/png;base64,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",
        };
    },
    computed: {},
    components: { HeaderItem, mobileFootter, appDowloadModule },
    mounted: function () {
        console.log(this.$route.query);
        this.appData = this.$route.query;
        this.initImg();
    },
    methods: {
        initImg() {
            if (this.$apis.sso == "http://hostsso.aeroiot.cn:9090/maxkey") {
                switch (this.appData.id) {
                    // 路网管理平台
                    case "33a17e90-2fbc-4b4a-b9d5-441a375b6fa5":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_highway.jpg";
                        break;
                    // 隧道监测 工程监测云
                    case "4c71616e-d03a-4d5c-81df-3c3d6c8696ac":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_tunnelop.jpg";
                        break;
                    // 河堤监测 工程监测云
                    case "06ef898c-e6b8-4cba-a256-1c5b3e97202e":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_reach.jpg";
                        break;
                    // 积水监测 工程监测云
                    case "fd661a9b-46be-4c3c-878d-476dfd8ba191":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_rain.jpg";
                        break;
                    // 边坡监测 工程监测云
                    case "e304f2b2-8141-4bc6-a690-77c47f4e95cc":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_slope.jpg";
                        break;
                    // 水库监测 工程监测云
                    case "76931b8e-392b-4f76-b08e-ec6c309352c9":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_reservoir.jpg";
                        break;
                    // 桥梁监测 工程监测云
                    case "38ccdfd5-2e74-42da-83e2-f2957fef97b8":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_bridge.jpg";
                        break;
                    // 大屏系统
                    case "917b8222-f403-4d71-9125-ad863eb37686":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_dashboard.jpg";
                        break;
                    // 隧道施工安全系统
                    case "3e631692-1c70-4dc1-8314-47952e357f88":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_tunnel.jpg";
                        break;
                    // 工程监测云
                    case "b930facb-3ad4-485b-80ed-cfeddb4f746c":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_monitor.jpg";
                        break;
                    // 隧道三维地质与实时监控系统
                    case "92fc9966-796d-4250-88ed-1b6f54573ffa":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_tunnelsanwei.jpg";
                        break;
                    // 经开区公共工程安全监测平台
                    case "7eb10741-4df6-455a-9f1b-e8806bba0033":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_city.jpg";
                        break;
                    // 道路检测系统
                    case "38acf402-0009-4dfa-86b9-7cb1c824b1ae":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_road.jpg";
                        break;
                    default:
                        this.previewImgUrl = "";
                }
            } else if (this.$apis.sso == "https://sso.aeroiot.cn/maxkey") {
                switch (this.appData.id) {
                    // 路网管理平台
                    case "f95540fd-2721-4d06-af9e-04908f496bd7":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_highway.jpg";
                        break;
                    // 隧道监测 工程监测云
                    case "498836c5-1bb8-41a1-bd0e-563628f3db2c":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_tunnelop.jpg";
                        break;
                    // 河堤监测 工程监测云
                    case "2377d331-524c-441a-be4d-cd20a7b04001":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_reach.jpg";
                        break;
                    // 积水监测 工程监测云
                    case "98774a44-0328-4ce7-b806-b4ed21448542":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_rain.jpg";
                        break;
                    // 边坡监测 工程监测云
                    case "b330cb0a-7448-402e-8982-f9b0b3952980":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_slope.jpg";
                        break;
                    // 水库监测 工程监测云
                    case "72831608-0898-4bc2-bfa0-ee18beea15ca":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_reservoir.jpg";
                        break;
                    // 桥梁监测 工程监测云
                    case "bc84fa8d-5e1c-4542-a6bc-c931ae503007":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_bridge.jpg";
                        break;
                    // 大屏系统
                    case "cc127130-f5d2-451d-b1b2-f41622d44ce4":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_dashboard.jpg";
                        break;
                    // 隧道施工安全系统
                    case "55a8e565-ec2b-4cdc-9004-1f125a11be2d":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_tunnel.jpg";
                        break;
                    // 工程监测云
                    case "85a84a1d-b092-4b7b-b906-d6242d2ba74a":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_monitor.jpg";
                        break;
                    // 隧道三维地质与实时监控系统
                    case "dd3c00ad-1702-4fc6-93a6-9f06ad8f9d1c":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_tunnelsanwei.jpg";
                        break;
                    // 经开区公共工程安全监测平台
                    case "2f4e2605-1443-4e14-b58a-ee3e480b5603":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_city.jpg";
                        break;
                    // 道路检测系统
                    case "2ede3100-33ce-4122-be15-ec3d087a2703":
                        this.previewImgUrl =
                            "https://htjc-usercenter.oss-cn-hangzhou.aliyuncs.com/iotapp/app-introduce-images/introduce_road.jpg";
                        break;
                    default:
                        this.previewImgUrl = "";
                }
            }
        },
        handleClose3() {
            this.dialogVisible3 = false;
        },
        openAPP() {
            this.$loading();
            var applistApi = this.$apis.openApply + "?appid=" + this.appData.id;
            this.$axios.get(applistApi).then(
                (response) => {
                    if (response.status === 200 && response.data) {
                        var result = response.data;
                        if (result.code === 200) {
                            this.$loading().close();
                            this.dialogVisible3 = true;
                        } else {
                            this.$loading().close();
                            this.$message.warning("申请开通失败，请稍后重试！");
                        }
                    } else {
                        this.$loading().close();
                        this.$message.warning("申请开通失败，请稍后重试！");
                    }
                },
                (error) => {
                    this.$loading().close();
                    this.$message.warning("申请开通失败，请稍后重试！");
                }
            );
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
    text-decoration: none;
}

.subject {
    /* 20220523 隐藏左侧栏 */
    /* position: absolute; */
    /* width: calc(100% - 50px); */
    width: 100%;
    min-height: 100vh;
    background-color: #eaedf5;
    left: 50px;
    display: flex;
    flex-direction: row;
}
.link-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fff;
}
.subject .list-group {
    width: 1408px;
    position: relative;
    margin: 63px 0px 0px 0px;
    min-height: 782px;
}
.subject .list-group .list-group-item {
    width: 170px;
    height: 42px;
    float: left;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    background-color: white;
    color: black;
}

.subject .list-group .list-group-item.active {
    background-color: #6c85ff;
    color: white;
}

/* .subject .list-group .list-group-item:hover {
  background-color: #6c85ff;
  color: white;
} */

.subject .list-group .panel {
    border-top: 1px solid;
    border-color: #e2e4e7;
    width: 100%;
    background-color: white;
}

.telephone {
    position: fixed;
    right: 13px;
    bottom: 140px;
    cursor: pointer;
}
.telephone .contact {
    display: none;
}
.telephone .contact span {
    position: absolute;
    top: 11px;
    left: 18px;
    font-size: 14px;
    font-family: "PingFang SC";
    font-weight: 600;
    line-height: 20px;
    color: #636363;
}
.telephone .contact .phone {
    position: absolute;
    top: 30px;
    left: 17px;
    font-size: 22px;
    color: #6c85ff;
    font-family: "Alibaba Sans";
    font-weight: bold;
    line-height: 34px;
    font-style: italic;
}
.telephone:hover .contact {
    cursor: pointer;
    position: absolute;
    right: 88px;
    top: 0px;
    display: block;
    width: 187.5px;
    height: 70px;
    border: 1px solid #6c85ff;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}
.telephone .contact:before {
    content: "";
    position: absolute;
    left: 100%;
    top: 29px;
    width: 8px;
    height: 8px;
    margin-left: -3.5px;
    background-color: rgb(255, 255, 255);
    border-top: 1px solid #6c85ff;
    border-right: 1px solid #6c85ff;
    transform: rotate(45deg);
    /* border-bottom: 4px solid transparent; */
    /* background-color: black; */
}
.AuthorizedServices {
    min-height: 740px;
}
.AuthorizedServices .apptype {
    font-size: 14px;
    margin-top: 16px;
    margin-left: 20px;
    margin-bottom: 11px;
    color: #070707;
    font-family: "PingFang SC";
    font-weight: 400;
    line-height: 20px;
}

.AuthorizedServices::-webkit-scrollbar-track {
    background-color: rgb(232, 232, 232);
}

.apptype2 {
    font-size: 14px;
    margin-left: 20px;
    color: #070707;
    font-family: "PingFang SC";
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 12px;
}
.grid-content {
    font-size: 14px;
    margin-bottom: 16px;
    margin-left: 20px;
    width: 280px;
    height: 99px;
    background-color: #f5f7fb;
    float: left;
    border: 1px solid gainsboro;
}

.grid-content2 {
    font-size: 14px;
    margin-bottom: 16px;
    margin-left: 20px;
    width: 280px;
    height: 99px;
    background-color: #ffffff;
    float: left;
    border: 1px solid gainsboro;
}

.grid-content .desc {
    display: flex;
    flex-direction: column;
    height: 99px;
    justify-content: center;
}

.grid-content .appname {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-family: "PingFang SC";
    color: #070707;
}

.grid-content a {
    text-decoration: none;
    font-size: 12px;
    color: #738bff;
}
.enterSystemButton {
    background: #ffffff;
    padding: 4px 10px;
    font-size: 12px;
    font-family: "PingFang SC";
    font-weight: 400;
    line-height: 17px;
    color: #738bff;
}
.dawdawdline {
    border-right: 1px dashed #e2e4e7;
    height: 11px;
    margin: 2px 10px 0 10px;
}
.appnameBox {
    display: flex;
    margin-top: 8px;
    flex-direction: row;
    align-items: center;
}
.grid-imgBox {
    width: 69px;
    height: 69px;
    background-color: #f5f7fb;
    border-radius: 50%;
    margin: 10px 15px 0 30px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.grid-imgBox img {
    width: 40px;
    height: 40px;
}
.experienceButton {
    color: #738bff;
    font-size: 12px;
    cursor: pointer;
}
.experienceButtonDialog /deep/ .el-dialog__header {
    padding: 14px 30px;
    background-color: #6c85ff;
    color: #ffffff;
}
.experienceButtonDialog /deep/ .el-dialog__headerbtn {
    top: unset;
}
.experienceButtonDialog /deep/ .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
}
.experienceButtonDialog /deep/ .el-dialog__close {
    color: #ffffff;
    font-size: 20px;
}
.experienceButtonDialog /deep/ .el-dialog__body {
    padding: 23px 50px 40px 50px;
}
.experienceButtonInDialog {
    width: 100px;
    height: 30px;
    background: #6c85ff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 auto;
    margin-top: 8px;
    cursor: pointer;
}
.experienceButtonDialogRightIcon {
    width: 49px;
    height: 49px;
    background: #6c85ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.experienceButtonDialogRightIcon .el-icon-check {
    color: #ffffff;
    font-size: 36px;
}
.experienceButtonDialogbottomline {
    width: 496px;
    border-top: 1px dashed #e2e4e7;
}
.experienceButtonDialog2 /deep/ .el-dialog__header {
    background-color: unset;
}
.experienceButtonDialog2 /deep/ .el-dialog__close {
    color: #9c9c9c;
    font-weight: 600;
}
.experienceButtonDialog2 /deep/ .el-dialog__body {
    padding: 23px 0px 30px 0px;
}
.experienceButtonInDialog2 {
    width: 265px;
    height: 43px;
    background: #6c85ff;
    border-radius: 112px;
}
.groupImgContent {
    width: 100%;
}
.groupImgContent img {
    width: 100%;
}
.list-group-header {
    margin-bottom: 20px;
}
.systemName {
    font-size: 18px;
    font-weight: 500;
    color: #222222;
}
.buttonContent {
    background-color: #fff;
    width: 100%;
}
.replayOpenButton {
    width: 322px;
    height: 41px;
    background: #6c85ff;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/mobileExperience/index.vue